import { render, staticRenderFns } from "./GpathAptitudeRecoEdit.vue?vue&type=template&id=7652ba36&scoped=true"
import script from "./GpathAptitudeRecoEdit.vue?vue&type=script&lang=js"
export * from "./GpathAptitudeRecoEdit.vue?vue&type=script&lang=js"
import style0 from "./GpathAptitudeRecoEdit.vue?vue&type=style&index=0&id=7652ba36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7652ba36",
  null
  
)

export default component.exports